export default "__VITE_ASSET__DOEPcKCd__"